import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class SourceInventoryModel extends BaseModel {
  grouped_inventory_uuid = null;
  quantity = null;
  source_inventory = null;
  source_inventory_uuid = null;

  rules = {
    source_inventory_uuid: 'required',
    quantity: 'required',
  };

  attributeHints = {
  };

  attributeLabels = {
  };

  toJSON() {
    let data = super.toJSON();
    return data;
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
